import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { AppCoreService } from "src/app/services/app-core.service";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NetworkService } from "src/app/services/network.service";
import { GeoService } from "src/app/services/geo.service";
import Swal from "sweetalert2";
import { CompanyService } from "src/app/services/company.service";
import { CommentValidation, RateValidation, MobileNumberValidation, regexPattern, TelephoneNumberValidation } from "src/app/models/validator";
import { EditDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/edit-delete.component";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { SupplementaryInvoiceService } from "src/app/services/misc/supplementary/supplementary.service";
import { Utilities } from "src/app/models/utilities";
import { debounceTime, distinctUntilChanged, lastValueFrom, map, Observable, OperatorFunction } from "rxjs";
import { Title } from "@angular/platform-browser";
import { MiscService } from "src/app/services/misc/misc.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";

@Component({
    selector: 'app-invoice',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})
export class SupplementaryInvoiceAddComponent implements OnInit, AfterViewInit {
    invoiceForm: FormGroup;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    isFormSubmitted = false;
    vendorList: any[];
    context: any;
    ServiceCenterOptions: [];
    companyList: any[];
    billTypeList = ['COD', 'Duty', 'Import', 'Import Duty'];
    documentOptions: any[] = [{ name: 'GSTIN (Normal)' }, { name: 'PAN Number' }, { name: 'Aadhaar Number' }, { name: 'Passport Number' }, { name: 'TAN Number' }, { name: 'VAT Number' }, { name: 'EORI' }, { name: 'FDA' }, { name: 'Others' }];
    billToResponse: any;
    formattedChargeList: any[];
    charCount: number;
    characterLimit = 150;
    CountReachedMsg = false;
    locationInfo: any
    // isBillToServiceCenter = false;
    editRowId: number;
    gridParams: any;
    isAdditionalSubmitted = false
    chargeList = [];
    ischargesFormEdit = false;
    selectedSCId = null;
    docValidationMsg: string;
    userData: any;
    addressBookList: any[] = [];
    resAddressBookList = [];

    private gridApi!: GridApi;
    private gridApi2!: GridApi;
    private gridColumnApi!: ColumnApi;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        domLayout: "autoHeight"
    };
    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        paginationPageSize: 10,
        suppressRowClickSelection: false,
        domLayout: "autoHeight"
    }
    rowData: any[] = [];
    columnDefs = [
        { headerName: 'Description', field: 'description', minWidth: 240 },
        { headerName: 'Amount', field: 'itemamount' },
        // {
        //     headerName: 'Fuel', field: 'isitemfuel',
        //     cellRenderer: (params: { value: boolean; }) => {
        //         let statusHtml = '<span class="badge  bg-warning">No</span>';
        //         if (params.value) {
        //             statusHtml = '<span class="badge bg-success">Yes</span>';
        //         }
        //         return statusHtml;
        //     },
        // },
        // { headerName: 'Fuel Amt', field: 'fuelamount' },
        // {
        //     headerName: 'Fuel Tax', field: 'fueltax',
        //     cellRenderer: (params: { value: boolean; }) => {
        //         let statusHtml = '<span class="badge  bg-warning">No</span>';
        //         if (params.value) {
        //             statusHtml = '<span class="badge bg-success">Yes</span>';
        //         }
        //         return statusHtml;
        //     },
        // },
        // { headerName: 'Fuel Tax Amt', field: 'fueltaxamount' },
        {
            headerName: 'Tax', field: 'tax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        // { headerName: 'Tax Amount', field: 'taxamount', minWidth: 90 },
        {
            headerName: 'IGST', field: 'igst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; igst: number; }; }) => {
                return params.data.tax ? params.data.igst : 0;
            }
        },
        {
            headerName: 'CGST', field: 'cgst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; cgst: number; }; }) => {
                return params.data.tax ? params.data.cgst : 0;
            }
        },
        {
            headerName: 'SGST', field: 'sgst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; sgst: number; }; }) => {
                return params.data.tax ? params.data.sgst : 0;
            }
        },
        { headerName: 'Total', field: 'itemtotal', minWidth: 120 },
        {
            headerName: 'Actions',
            field: 'id',
            // cellRendererParams: { context: this },
            cellRenderer: EditDeleteActionsRenderer,
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 50,
            pinned: 'right',
            filter: false
        },
    ];

    chargesOptions: any = [];
    customerConfig: any = {};
    useEnterKey: any;
    stateList: any;
    selectedStateTaxCode
    limitChars: number;
    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private serviceCenter: NetworkService,
        private ngxLoaderService: NgxUiLoaderService,
        private invoiceService: SupplementaryInvoiceService,
        private geoService: GeoService,
        private router: Router,
        private companyService: CompanyService,
        private chargesService: ChargesService,
        private utilities: Utilities,
        private titleService: Title,
        private addressbookService: AddressBookService,
        private rateUploadService: RateUploadService
    ) {
        titleService.setTitle('Supplementary');
        this.context = { componentParent: this };
    }
    currentDate = this.formateDate(new Date()).dateString;

    ngOnInit(): void {
        this.invoiceForm = this.formBuilder.group({
            ddlBillType: [null, Validators.required],
            ddlCompany: [null, Validators.required],
            ddlServiceCenter: [null],
            txtInvoiceDate: [this.currentDate],
            txtInvoiceNo: [null],
            txtBOEDate: [this.utilities.FormatDateWithTime().dateString],
            txtBOENo: [null],
            txtAwbNo: [null, Validators.required],
            switchSenderRecv: ['sender'],

            infoForm: this.formBuilder.group({
                txtName: [null],
                txtConatctPerson: [null],
            }),

            billingInfoForm: this.formBuilder.group({
                ddlDocumentType: [null],
                ddlDocumentNo: [{ value: null, disabled: true }],
                txtRemark: [null],
            }),

            chargesForm: this.formBuilder.group({
                txtDescription: [null],
                txtAmount: [null, RateValidation],
                // chkFuel: ['No'],
                // txtFuelAmt: [{ value: 0.00, disabled: true }],
                // chkFuelTax: ['No'],
                // txtFuelTaxAmount: [{ value: 0.00, disabled: true }],
                chkTax: ['No'],
                txtTaxAmount: [{ value: 0.00, disabled: true }],
                txtTotal: [{ value: 0.00 }]
            }),

            locationForm: this.formBuilder.group({
                ddlCountry: [null],
                ddlState: [null],
                ddlCity: [null],
                txtPincode: [null],
                txtAddress1: [null],
                txtAddress2: [null],
                txtArea: [null],
                txtMobileNo: [null, MobileNumberValidation],
                txtTelephoneNo: [null, TelephoneNumberValidation],
            }),

        });
        this.checkPermission();
        if (this.permConfig.isAddAllowed) {
            this.userData = this.appCoreService.GetUserData();
            this.getAllServiceCenter();
            this.getAllCompanies();
            // this.invoiceForm.get('locationForm').disable();
            this.appCoreService.SelectedServiceCenter().subscribe((val) => {
                this.selectedSCId = val;
            });
            this.bindAddressBook();
            this.bindDescription();
        }
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceForm) : null;
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Supplementary');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    getLocation(selectedLocation: any) {
        this.stateList = selectedLocation?.[0]?.state;
    }

    documentTypeValidation(docType?): void {
        docType = docType? docType: this.invoiceForm.get('billingInfoForm').get('ddlDocumentType').value;
        this.invoiceForm.get('billingInfoForm').get('ddlDocumentNo').enable();
        const docNoControl = this.invoiceForm.get('billingInfoForm').get('ddlDocumentNo');
        docNoControl.reset();

        let msg: string;
        let regex: any;
        let chars: number;
        // Get the dynamic state code
        const stateisocode = this.invoiceForm.get('locationForm.ddlState')?.value
        const taxtCode = this.stateList?.find(row => row.isocode === stateisocode)?.taxcode;
        this.selectedStateTaxCode = taxtCode;
        // Dynamically create the GSTIN regex pattern based on the state code
        const gstPattern = `^(${taxtCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`;
        regexPattern.gstValidation = new RegExp(gstPattern);  // Update regex pattern

        // Assign regex, message, and limitChars based on docType
        switch (docType) {
            case 'Aadhaar Number':
                regex = regexPattern.adhaarValidation;
                msg = 'Invalid Aadhaar No. Format.';
                chars = 12;
                break;
            case 'PAN Number':
                regex = regexPattern.panValidation;
                msg = 'Invalid PAN No. Format.';
                chars = 10;
                break;
            case 'GSTIN (Normal)':
                regex = regexPattern.gstValidation;
                msg = 'Invalid GST No. Format.';
                chars = 15;
                break;
            case 'Others':
                regex = regexPattern.maxCharacterDocValidation;
                msg = 'Max 150 characters allowed.';
                chars = 150;
                break;
            default:
                regex = regexPattern.generalDocValidation;
                msg = 'Max 30 characters allowed.';
                chars = 30;
                break;
        }

        // Store the limitChars and validation message for use in the template if needed
        this.docValidationMsg = msg;
        this.limitChars = chars;  // Added storing limitChars for external access

        // Set Validators with limitChars and regex validation
        docNoControl.setValidators([Validators.required, Validators.pattern(regex)]);
        docNoControl.updateValueAndValidity();
    }

    validateGSTINStateSelection(isinputGSTValue: string) {
        if (isinputGSTValue && !this.invoiceForm.get('locationForm.ddlState')?.value && this.invoiceForm.get('billingInfoForm').get('ddlDocumentType').value === 'GSTIN (Normal)') {
            this.invoiceForm.get('billingInfoForm').get('ddlDocumentNo').reset();
            this.appCoreService.showMessage('Please Select State to Validate GSTIN', '', 'error');
        }
    }

    bindBillToDetails(switchType: string) {
        this.ngxLoaderService.start();
        this.locationInfo = {}
        if (this.billToResponse && this.billToResponse.length) {
            //awbnumber found map billto details and billing info ABC12345
            const shipper = this.billToResponse.filter(x => x.addressbook_type == 'Shipper');
            // console.log("shipper", shipper);
            const consignee = this.billToResponse.filter(x => x.addressbook_type == 'Consignee');
            // console.log("consignee", consignee);

            if (switchType == 'shipper' && shipper?.length) {
                this.documentTypeValidation(shipper[0]?.kycinfo.type);

                this.locationInfo = shipper[0].details;

                let selectedLocName = { name: shipper[0].name };

                //this.invoiceForm.get('txtName').setValue(shipper[0].name);
                //this.invoiceForm.get('txtConatctPerson').setValue(shipper[0].contactperson);

                this.invoiceForm.get('infoForm').patchValue({
                    txtName: selectedLocName,
                    txtConatctPerson: shipper[0].contactperson
                });

                this.invoiceForm.get('billingInfoForm').patchValue({
                    ddlDocumentNo: shipper[0]?.kycinfo.no,
                    ddlDocumentType: shipper[0]?.kycinfo.type,
                });
            }
            if (switchType == 'consignee' && consignee?.length) {
                this.documentTypeValidation(consignee[0]?.kycinfo.type);

                this.locationInfo = consignee[0].details;

                let selectedLocName = { name: consignee[0].name };
                this.invoiceForm.get('infoForm').patchValue({
                    txtName: selectedLocName,
                    txtConatctPerson: consignee[0].contactperson
                });

                this.invoiceForm.get('billingInfoForm').patchValue({
                    ddlDocumentNo: consignee[0]?.kycinfo?.no,
                    ddlDocumentType: consignee[0]?.kycinfo?.type,
                });
            }
        }
        this.ngxLoaderService.stop();
    }

    getBillToDetails(): void {
        this.invoiceForm.get('locationForm').reset();
        this.invoiceForm.get('billingInfoForm').reset();
        const awbNumber = this.invoiceForm.get('txtAwbNo')?.value?.trim();
        const billToParam = this.invoiceForm.get('switchSenderRecv').value == 'sender' ? 'Shipper' : 'Consignee';
        const reqObj = {
            awbNumber: awbNumber,
            billTo: billToParam,
            generatedfromid: this.selectedSCId
            // generatedfromid: this.isBillToServiceCenter ? this.selectedSCId : null  // changes made by Rahim after it was no longer mandatory to include the service center, whereas it was previously required.
        }
        if (awbNumber) {
            this.ngxLoaderService.start();
            this.invoiceService.GetBillToDetails(reqObj).subscribe(async res => {
                // console.log('GetAllAwb', res);
                if (res) {
                    if (res && !res.success) {
                        this.ngxLoaderService.stop();
                        this.billToResponse = null;
                        this.appCoreService.showMessage(res.message, 'Error', 'error');
                    }
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.isFormSubmitted = false;
                        this.isAdditionalSubmitted = false;
                        if (res.data && !res.data.length) {
                            this.invoiceForm.get('txtAwbNo').reset();
                            return this.appCoreService.showMessage('No airway bill record found', 'No data found', 'error');
                        }
                        this.billToResponse = res.data[0]?.addressbookdetails;
                        this.bindBillToDetails('shipper');
                        let requestObj = {
                            customer: res.data[0]?.customerid || null,
                            searchtype: !res.data[0]?.customerid ? 'Tariff' : 'Customer',
                            product: res.data[0]?.productid,
                            bookingdate: res.data[0]?.bookingdate,
                            company: res.data[0]?.companyid
                        }
                        this.getCustomerApplicableTax(requestObj);
                    }
                }
            })
        }
    }

    getCustomerApplicableTax(data: any): void {
        try {
            let reqObj = {
                customer: data.customer || null,
                searchtype: !data.customer ? 'Tariff' : 'Customer',
                product: data.product,
                bookingdate: data.bookingdate,
                company: data.company
            }

            this.rateUploadService.getCustomerTaxes(reqObj).subscribe((res) => {
                if (res) {
                    this.customerConfig.tax = {
                        igst: Number(res.data?.[0]?.igst  ?? 0),
                        cgst: Number(res.data?.[0]?.cgst ?? 0),
                        sgst: Number(res.data?.[0]?.sgst ?? 0),
                        igstapplicable: res.data?.[0]?.isIGSTApplicable || false
                    }
                }
            });
        } catch (error) {
        }
    }

    generateInvoice() {
        this.isFormSubmitted = true;
        this.rowData.length ? this.setValidators('clear') : this.setValidators('add');

        if (this.selectedStateTaxCode) {
            const documentStateTaxCode = this.invoiceForm.value.billingInfoForm.ddlDocumentNo?.slice(0, 2);
            const isGstValid = this.selectedStateTaxCode === documentStateTaxCode;
            if (!isGstValid)
                return this.appCoreService.showMessage('Invalid GST No format', 'Error', 'error');
        }

        if (this.invoiceForm.valid && this.billToResponse.length) {
            const formData: FormGroup = this.invoiceForm;
            try {
                const reqObj = {
                    billtype: formData.value.ddlBillType,
                    companyid: formData.value.ddlCompany,
                    //servicecenterid: formData.value.ddlServiceCenter,
                    generatebyservicecenterid: this.selectedSCId,
                    invoicedate: this.formateDate(formData.value.txtInvoiceDate).dateString,
                    invoiceno: formData.value.txtInvoiceNo,
                    boeno: formData.value.txtBOENo,
                    boedate: formData.value.txtBOEDate,
                    awbnumber: formData.value.txtAwbNo,
                    billto: formData.value.switchSenderRecv == 'sender' ? 'Shipper' : 'Consignee',
                    billingtodetails: this.locationInfo,
                    billinginfo: {
                        documenttype: formData.value.billingInfoForm.ddlDocumentType || null,
                        documentno: formData.value.billingInfoForm.ddlDocumentNo || null,
                        remark: formData.value.billingInfoForm.txtRemark || null
                    },
                    charges: {
                        awbnumber: this.invoiceForm.get('txtAwbNo').value,
                        chargetype: formData.value.switchSenderRecv == 'sender' ? 'Shipper' : 'Consignee',
                        contractchargesamount: 0.00,

                        otherchargesamount: this.rowData.reduce((sum, item) => { return sum + item.itemamount }, 0),
                        subtotal: this.rowData.reduce((sum, item) => { return sum + item.itemamount }, 0),

                        totalfuel: 0,
                        taxes: {
                            tax: {
                                vat: 0.00,
                                cgst: this.rowData.reduce((sum, item) => { return sum + item.cgst }, 0),
                                igst: this.rowData.reduce((sum, item) => { return sum + item.igst }, 0),
                                sgst: this.rowData.reduce((sum, item) => { return sum + item.sgst }, 0)
                            },
                            type: 'gst'
                        },
                        totalamount: this.rowData.reduce((sum, item) => { return sum + item.itemtotal }, 0),
                    },
                    chargesList: this.rowData.map(row => ({
                        ...row,
                        awbnumber: this.invoiceForm.get('txtAwbNo').value
                    }))
                };
                reqObj.billingtodetails.name = formData.value.infoForm.txtName.name;
                reqObj.billingtodetails.contactperson = formData.value.infoForm.txtConatctPerson;
                // console.log(reqObj);
                this.ngxLoaderService.start();
                this.invoiceService.Generate(reqObj).subscribe(res => {
                    // console.log(res);
                    if (res && !res.success) {
                        this.ngxLoaderService.stop();
                        this.openWarningDialog(res?.message);
                        //this.appCoreService.showMessage(res?.message, 'Error', 'error');
                    }
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.openSuccessDialog('Invoice generated successfuly');
                    }
                })
            } catch (error) {
                console.log(error);
                this.ngxLoaderService.stop();
            }

        }
    }

    chargesModel() {
        const chargeDetailForm = this.invoiceForm.get('chargesForm');
        const description = chargeDetailForm.get('txtDescription')?.value;
        const charge = this.calculateTaxCharge();
        const newData = {
            id: 0,
            chargetype: 'supplementary',
            chargesid: chargeDetailForm.get('txtDescription').value,
            description: this.chargeList.find(x => x.id === description)?.name || '',
            itemamount: parseFloat(chargeDetailForm.get('txtAmount').value),
            isitemfuel: false,
            fuelamount: 0,
            fueltax: false,
            fueltaxamount: 0,
            itemtotal: chargeDetailForm.get('txtTotal').value,
            tax: chargeDetailForm.get('chkTax').value === 'Yes',
            taxamount: chargeDetailForm.get('txtTaxAmount').value,
            igst: (Number(charge.igst) || 0).toFixed(3),
            sgst: (Number(charge.sgst) || 0).toFixed(3),
            cgst: (Number(charge.cgst) || 0).toFixed(3),
            taxtype: 'gst'
        };
        // console.log(newData);
        return newData;
    }

    setValidators(condition: string) {
        if (condition == 'add') {
            this.isAdditionalSubmitted = true;
            this.invoiceForm.get('chargesForm').get('txtDescription').setValidators([Validators.required])
            this.invoiceForm.get('chargesForm').get('txtAmount').setValidators([Validators.required])
        } else {
            this.invoiceForm.get('chargesForm').get('txtDescription').clearValidators()
            this.invoiceForm.get('chargesForm').get('txtAmount').clearValidators()
        }
        this.invoiceForm.get('chargesForm').get('txtDescription').updateValueAndValidity()
        this.invoiceForm.get('chargesForm').get('txtAmount').updateValueAndValidity()
    }

    upsertCharge(operationtype: string) {
        this.isAdditionalSubmitted = true;
        const chargeDetailForm = this.invoiceForm.get('chargesForm');
        const description = chargeDetailForm.get('txtDescription')?.value;
        const itemamount = chargeDetailForm.get('txtAmount')?.value;

        if (!description || !itemamount) {
            return;
        }
        let newData = this.chargesModel();
        //calculate charges for total 
        newData = this.calculateTotalCharge(newData);
        if (operationtype === 'insert') {
            this.formattedChargeList.map(row => row.id);
            const isChargeIdInRowData = this.rowData.some(x => x.chargesid == newData.chargesid);
            if (isChargeIdInRowData) {
                this.isAdditionalSubmitted = false;
                this.resetChargesForm();
                return this.appCoreService.showMessage('This Charge is already present in List. Please modify if correction needed.', 'Warning', 'warning');
            }
            newData.id = this.rowData.length;
            this.rowData = [...this.rowData, newData];
            this.resetChargesForm();
        }
        else if (operationtype === 'update') {
            const indexToUpdate = this.rowData.findIndex(x => x.id === this.editRowId);
            if (indexToUpdate !== -1) {
                // Remove the element from its original position
                this.rowData.splice(indexToUpdate, 1);
                this.rowData.forEach((element, index) => {
                    element.id = index;
                });
                // Update the id of newData
                newData.id = this.rowData.length;
                this.rowData = [...this.rowData, newData]
                this.resetChargesForm();
            }
        }
        this.isAdditionalSubmitted = false;
    }

    calculateTotalCharge(data?: any) {
        this.setValidators('add');
        data = data ? data : this.chargesModel();
        data.itemtotal =
            (parseFloat(data.itemamount)) +
            (data.isitemfuel ? parseFloat(data.fuelamount) : 0) +
            (data.fueltax ? parseFloat(data.fueltaxamount) : 0) +
            (data.tax ? parseFloat(data.taxamount) : 0);
        this.invoiceForm.get('chargesForm').get('txtTotal').setValue(parseFloat(data.itemtotal));
        return data;
    }

    editAction(cell: any) {
        this.ischargesFormEdit = true;
        this.editRowId = cell.rowIndex;
        const form = this.invoiceForm.get('chargesForm');
        form.patchValue({
            txtDescription: this.chargeList.find(x => x.name === cell.description)?.id,
            txtTotal: cell.itemtotal,
            txtAmount: cell.itemamount,
            // chkFuel: 'No',
            // txtFuelAmt: 0,
            // chkFuelTax: 'No',
            // txtFuelTaxAmount: 0,
            chkTax: cell.tax ? 'Yes' : 'No',
            txtTaxAmount: cell.taxamount
        });
    }

    async deleteAction(cell: any) {
        if (cell) {
            const confirmed = await this.openConfirmationDialog('Are you sure?', 'You want to remove this Charge.');
            if (confirmed) {
                const indexToRemove = this.rowData.findIndex(row => row.id === cell.id);
                if (indexToRemove !== -1) {
                    this.rowData.splice(indexToRemove, 1);
                    this.rowData = [...this.rowData];
                }

            }
        }
    }

    resetChargesForm() {
        this.ischargesFormEdit = false;
        const form = this.invoiceForm.get('chargesForm');
        form.reset({
            txtDescription: null,
            // chkFuel: 'No',
            // chkFuelTax: 'No',
            chkTax: 'No',
            txtTotal: 0.00,
            txtAmount: null,
            // txtFuelAmt: 0.00,
            // txtFuelTaxAmount: 0.00,
            txtTaxAmount: 0.00
        });
    }

    async getAllCompanies() {
        try {
            const res = await lastValueFrom(this.companyService.GetAll({ isactive: true }));
            if (res && res.success) {
                this.companyList = res.data;
                //select default
                this.invoiceForm.get('ddlCompany').setValue(this.companyList.find(x => x.isdefault).id);
                //this.onChangeCompany();
            }

        } catch (e) {
            console.error(e);
        }
    }

    // onChangeCompany() {
    //     //if billto company then show service center
    //     if (this.companyList.find(x => x.id == this.invoiceForm.get('ddlCompany').value)?.billto == 'Company') {
    //         this.isBillToServiceCenter = false;
    //         this.invoiceForm.get('ddlServiceCenter').clearValidators();
    //     } else {
    //         this.isBillToServiceCenter = true;
    //         this.invoiceForm.get('ddlServiceCenter').setValidators([Validators.required]);
    //     }
    //     this.invoiceForm.get('ddlServiceCenter').updateValueAndValidity();
    // }

    getAllServiceCenter() {
        try {
            this.serviceCenter.GetAllServiceCenters().subscribe((res) => {
                if (res && res.success) {
                    this.ServiceCenterOptions = res.data;
                } else {
                }
            });
        } catch (e) {
            console.error(e);
        }
    }


    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    async openConfirmationDialog(msg1: any, msg2?: any): Promise<boolean> {
        const result = await Swal.fire({
            titleText: 'Confirmation',
            html: msg2 ? `<span>${msg1}</span><br><span>${msg2}</span>` : `<span>${msg1}</span>`,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            return true;
        }
    }

    async openWarningDialog(msg: any) {
        Swal.fire({
            // title: 'Oops!',
            html: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }

    async openSuccessDialog(msg: any) {
        const result = await Swal.fire({
            html: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            this.router.navigate(['/invoices/supplementary']);
        }
    }

    bindDescription() {
        try {
            this.chargesService.GetAll().subscribe((res) => {
                if (res && res.success) {
                    // console.log("res.data", res.data);
                    this.chargeList = res.data.length ? res.data.filter(item => item.chargetype.map(type => type.toLowerCase()).includes('supplementary')) : null;
                    this.formattedChargeList = this.chargeList;
                }
            });
        }
        catch (err) {
            console.error(err);
        }
    }

    onGridReady(params: GridReadyEvent) {
        this.gridParams = params;
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }
    countCharcter() {
        const billingInfoForm = this.invoiceForm.get('billingInfoForm');
        const remark = billingInfoForm.get('txtRemark');
        this.charCount = remark.value?.length;
        if (this.charCount >= this.characterLimit + 1) {
            remark.setValidators([CommentValidation]);
            this.CountReachedMsg = true;
        } else {
            remark.clearValidators();
            this.CountReachedMsg = false;
        }
        remark.updateValueAndValidity();
    }

    formatter = (x: { name: string }) => x.name;

    selectedItemEvent(item) {
        try {
            this.bindLocationDetails(item.item);
            //this.getSelectedAddressKycInfo.emit(item?.item?.kycinfo);
            // this.shipper = item.item;
        } catch (e) {

        }
    }

    async bindLocationDetails(currLoc) {
        try {
            this.locationInfo = currLoc.location;
        }
        catch (e) {
            console.error(e);
        }
    }

    search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.addressBookList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );

    bindAddressBook() {
        try {
            this.addressbookService.GetAll({ industrytypeid: null, isactive: true, customerid: this.userData?.metaInfo?.customerid }).subscribe((res) => {
                if (res && res.success) {
                    this.addressBookList = res?.data;
                    this.resAddressBookList = res?.data;
                };
            });
        } catch (e) {
            console.error(e);
        }
    }

    calculateReverseAmount(): void {
        const finalAmount = parseFloat(this.invoiceForm.get('chargesForm.txtTotal').value) || 0;
        // const chkFuel = this.chargeForm.get('chargesdetails.chkItemFuel').value;
        // const chkfuelTax = this.chargeForm.get('chargesdetails.chkFuelTax').value;
        const chkTax = this.invoiceForm.get('chargesForm.chkTax').value;

        const igst = this.customerConfig?.tax?.igst || 0;
        const cgst = this.customerConfig?.tax?.cgst || 0;
        const sgst = this.customerConfig?.tax?.sgst || 0;
        const igstapplicable = this.customerConfig?.tax?.igstapplicable || false;

        let totaltax = igstapplicable ? igst : (cgst + sgst);
        
        const tax = totaltax || 0;
        // const fuel = this.customerConfig?.fuel?.fuelcharge || 0;

        const taxPct = tax && chkTax === 'Yes' ? (tax + 100) : 100;
        // const fuelPct = fuel && chkFuel === 'Yes' ? (fuel + 100) : 100;

        let returnAmount = taxPct ? (finalAmount / taxPct * 100) : finalAmount;
        // const returnAmount1 = fuelPct ? (returnAmount / fuelPct * 100) : returnAmount;

        // if (returnAmount1 > 0) {
        //     returnAmount = returnAmount1;
        // }

        // const fuelAmount = fuel && chkFuel === 'Yes' ? (returnAmount * fuel / 100) : 0;
        const taxAmount = tax && chkTax === 'Yes' ? (returnAmount * tax / 100) : 0;
        // const fuelTaxAmount = tax && fuelAmount && chkfuelTax === 'Yes' ? (fuelAmount * tax / 100) : 0;

        this.invoiceForm.get('chargesForm.txtAmount').setValue(Number(returnAmount).toFixed(3));
        // this.chargeForm.get('chargesdetails.txtFuelAmt').setValue(Number(fuelAmount).toFixed(3));
        // this.chargeForm.get('chargesdetails.txtFuelTaxAmount').setValue(Number(fuelTaxAmount).toFixed(3));
        this.invoiceForm.get('chargesForm.txtTaxAmount').setValue(Number(taxAmount).toFixed(3));
    }

    calculateFuelTax(event?: any, isDescriptionChanged: boolean = false, manual = false) {
        const chargesdetails = this.invoiceForm.get('chargesForm');
    
        let chargeid = event?.id ?? chargesdetails.get('txtDescription').value;
        
        if (isDescriptionChanged) {
            ['txtAmount', 'txtTaxAmount', 'chkTax', 'txtTotal']
                .forEach(field => chargesdetails.get(field).reset());
        }
    
        let chargeDetailObj = this.formattedChargeList.find(x => x.id === chargeid);
        let chargeAmount = Number(chargesdetails.get('txtAmount').value ?? chargeDetailObj?.amount ?? 0);
    
        const isTaxApplicableOnCharge = manual ? chargesdetails.get('chkTax').value === 'Yes' : chargeDetailObj?.tax;
        // const isFuelTaxApplicableOnCharge = manual ? chargesdetails.get('chkFuelTax').value === 'Yes' : chargeDetailObj?.taxonfuel;
        // const isFuelApplicableOnCharge = manual ? chargesdetails.get('chkItemFuel').value === 'Yes' : chargeDetailObj?.fuel;
    
        let fuelAmount = 0;
        // if (isFuelApplicableOnCharge) {
        //     let calculationBy = this.customerConfig?.fuel?.calculationby || "";
        //     let chargableFuel = Number(this.customerConfig?.fuel?.fuelcharge ?? 0);
    
        //     fuelAmount = calculationBy.toLowerCase() === "percentage"
        //         ? (chargeAmount * (chargableFuel / 100))
        //         : (calculationBy.toLowerCase() === "amount" ? chargableFuel : 0);
        // }
    
        let fuel_igst = 0, fuel_sgst = 0, fuel_cgst = 0, taxFuelAmount = 0;
        let item_igst = 0, item_sgst = 0, item_cgst = 0, taxAmount = 0;
    
        const { igst = 0, sgst = 0, cgst = 0, is_igst_applicable = false } = this.customerConfig?.tax || {};
    
        if (isTaxApplicableOnCharge) {
            // if (isFuelTaxApplicableOnCharge) {
            //     if (is_igst_applicable) {
            //         fuel_igst = fuelAmount * (igst / 100);
            //     } else {
            //         fuel_sgst = fuelAmount * (sgst / 100);
            //         fuel_cgst = fuelAmount * (cgst / 100);
            //     }
            //     taxFuelAmount = fuel_igst + fuel_sgst + fuel_cgst;
            // }
    
            if (is_igst_applicable) {
                item_igst = chargeAmount * (igst / 100);
            } else {
                item_sgst = chargeAmount * (sgst / 100);
                item_cgst = chargeAmount * (cgst / 100);
            }
            taxAmount = item_igst + item_sgst + item_cgst;
        }
    
        const item_total = chargeAmount + fuelAmount + taxFuelAmount + taxAmount;
    
        chargesdetails.get('txtAmount').setValue(chargeAmount.toFixed(3));
        // !manual && chargesdetails.get('chkItemFuel').setValue(chargeDetailObj?.fuel ? 'Yes' : 'No');
        // chargesdetails.get('txtFuelAmt').setValue(fuelAmount.toFixed(3));
        // !manual && chargesdetails.get('chkFuelTax').setValue(chargeDetailObj?.taxonfuel ? 'Yes' : 'No');
        // chargesdetails.get('txtFuelTaxAmount').setValue(taxFuelAmount.toFixed(3));
        !manual && chargesdetails.get('chkTax').setValue(chargeDetailObj?.tax ? 'Yes' : 'No');
        const validTaxAmount = isNaN(taxAmount) ? 0 : taxAmount;
        chargesdetails.get('txtTaxAmount').setValue(validTaxAmount.toFixed(3));

        chargesdetails.get('txtTotal').setValue(item_total.toFixed(3));
    }

    calculateTaxCharge(): { igst: number, cgst: number, sgst: number, totaltax: number } {
        const itemamount = Number(this.invoiceForm.get('chargesForm.txtAmount')?.value) || 0;

        let igst = 0, cgst = 0, sgst = 0;

        if (this.customerConfig?.tax?.igst && this.customerConfig?.tax?.igstapplicable) {
            igst = (itemamount * Number(this.customerConfig.tax.igst)) / 100 || 0;
        } else {
            if (this.customerConfig?.tax?.cgst) {
                cgst = (itemamount * Number(this.customerConfig.tax.cgst)) / 100 || 0;
            }

            if (this.customerConfig?.tax?.sgst) {
                sgst = (itemamount * Number(this.customerConfig.tax.sgst)) / 100 || 0;
            }
        }

        const taxAmount = Number(igst) + Number(cgst) + Number(sgst);
        const totaltax = taxAmount || 0;

        return { igst, cgst, sgst, totaltax };
    }
}
